import { render, staticRenderFns } from "./QLeadDataTable.vue?vue&type=template&id=3cca81bb&scoped=true&"
import script from "./QLeadDataTable.vue?vue&type=script&lang=js&"
export * from "./QLeadDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QLeadDataTable.vue?vue&type=style&index=0&id=3cca81bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca81bb",
  null
  
)

export default component.exports